import { render, staticRenderFns } from "./ProductRelatedCarousel.vue?vue&type=template&id=4332419e&scoped=true"
import script from "./ProductRelatedCarousel.vue?vue&type=script&lang=js"
export * from "./ProductRelatedCarousel.vue?vue&type=script&lang=js"
import style0 from "./ProductRelatedCarousel.vue?vue&type=style&index=0&id=4332419e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4332419e",
  null
  
)

export default component.exports